export default __webpack_public_path__ + "static/media/headerlogo-white.59e85bfe.svg";